<template>
    <form autocomplete="off" class="trax-form-with-icons" v-on:submit.prevent="search">
    
        <!-- Pinned -->

        <trax-ui-toggle text="Only favorite learners" v-model="form.pinned">
        </trax-ui-toggle>

        <!-- Submit buttons -->

        <div class="trax-form-actions text-right">
            <button type="button" class="btn btn-default btn-link" @click="reset"> {{ lang.polaris.form.reset }} </button>
            <button type="submit" class="btn btn-primary btn-round"> {{ lang.polaris.form.search }} </button>
        </div>

    </form>
</template>

<script>
    export default {
    
        props: {
            id: null,
            bus: null
        },
        
        data: function() {
            return {
                lang: lang,
                user: user,
                form: {}
            }
        },
        
        created: function() {
            var that = this;

            this.bus.$on(this.id+'-filter-restore', function (data) {
                that.form = data;
            });
        },

        computed: {

            statusSelect() {
                var select = window.data.status_select;
                if (!this.archivePermission) {
                    for (var i in select) {
                        if (select[i].value == 'archived') break;
                    }
                    select.splice(i, 1);
                }
                return select;
            },

            archivePermission() {
                return this.user.admin 
                    || this.user.permissions['dashboard.access-archives']
                    || this.user.permissions['dashboard.read-all']
                    || this.user.permissions['dashboard.write-all'];
            }
        },

        methods: {

            search() {
                this.bus.$emit(this.id+'-filter', this.form);
                this.bus.$emit(this.id+'-search-close');
            },

            reset() {
                this.form = {};
                this.search();
            }
        }
            
    }
</script>
